import { render } from "./Secondary5.vue?vue&type=template&id=e2a029cc&ts=true"
import script from "./Secondary5.vue?vue&type=script&lang=ts"
export * from "./Secondary5.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Secondary5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2a029cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2a029cc', __exports__)) {
    api.reload('e2a029cc', __exports__)
  }
  
  module.hot.accept("./Secondary5.vue?vue&type=template&id=e2a029cc&ts=true", () => {
    api.rerender('e2a029cc', render)
  })

}


export default __exports__